import { render } from "./DebitNote.vue?vue&type=template&id=6264d94a&scoped=true"
import script from "./DebitNote.vue?vue&type=script&lang=js"
export * from "./DebitNote.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=6264d94a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6264d94a"]])

export default __exports__